import React from "react";
import { CompatibleWithResult } from "./CompatibleWithResult";
import SpecialOrders from "~/common/SpecialOrders";
import ResourcesAndDownloads from "~/common/ResourcesAndDownloads/ResourcesAndDownloads";
import useIsMounted from "~/common/useIsMounted";
import ExternalLinkModal from "~/common/ExternalLinkModal/ExternalLinkModal";
import ChromeAndProducts from "./ChromeAndProducts";
import FeatureFlagProvider from "~/common/contexts/FeatureFlagProvider";

const CompatibleWithPage = ({
  featureFlags = {},
  pageHeader,
  product,
  pagination,
  replacementParts,
  accessories,
  linkedResources,
  facetNavigation,
}: CompatibleWithResult) => {
  const mounted = useIsMounted();

  const hasExternalLinks =
    product?.documents?.filter((x) => x.externalUrl?.length).length > 0;

  const backToProductPageH2 = (
    <h2 className="page-header-2">
      <a href={product ? product.link : ""}>Back to Product Page</a>
    </h2>
  );

  return (
    <FeatureFlagProvider featureFlags={featureFlags}>
      <div
        className="product-page compatibleWith container"
        data-module="initCompatibleWithPage"
      >
        {mounted && hasExternalLinks && <ExternalLinkModal />}
        <div className="text-content">
          <h1 className="page-header">{pageHeader}</h1>
          {product && product.link && backToProductPageH2}
        </div>
        <div id="page" className="showcase fixed-side-right clears">
          <div id="main">
            <div className="fixed-go-to-top clears no-sidebar">
              <div className="no-sidebar no-filter container-product-listing">
                <ChromeAndProducts
                  title="Replacement Parts"
                  displayProducts={replacementParts}
                  pagination={pagination}
                  facetNavigation={facetNavigation}
                />
                <ChromeAndProducts
                  title="Accessories"
                  displayProducts={accessories}
                  pagination={pagination}
                  facetNavigation={facetNavigation}
                />
              </div>
            </div>
          </div>
          <div id="sidebar" className="aside">
            <ResourcesAndDownloads
              manufacturerItemNumberDisplayText=""
              productDocuments={product?.documents}
              productDisclaimer={product?.disclaimers}
              linkedResources={linkedResources}
            />
            <SpecialOrders />
          </div>
        </div>
      </div>
    </FeatureFlagProvider>
  );
};

export default CompatibleWithPage;
